const inputTypeEnum = {
  text: "text",
  select: "select",
  checkbox: "checkbox",
  richText: "richText",
  date: "date",
  hidden: "hidden",
  file: "file",
};

export default inputTypeEnum;
